import { Component, OnInit } from '@angular/core';
import { Candidates } from '../../models/candidates.model';
import { Router } from '@angular/router';
import { FunctionsService } from '../../services/functions.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-admin-candidate-profile',
  templateUrl: './admin-candidate-profile.component.html',
  styleUrls: ['./admin-candidate-profile.component.scss']
})
export class AdminCandidateProfileComponent implements OnInit {
  candidate: Candidates = new Candidates({});

  constructor(public functionsService: FunctionsService, private router: Router) { }

  ngOnInit(): void {
    if (localStorage.getItem('details-candidate-apply') && localStorage.getItem('details-candidate-apply') != undefined) {
      const data: any = JSON.parse(localStorage.getItem("details-candidate-apply") || "");
      
      this.candidate = new Candidates(data);
      
    } else {
      this.router.navigate(['not-found']);
    }
  }
  
  formatFilePath(file_path: string): string {
    return (file_path != null && file_path != '') ? environment.apiUrl + file_path : file_path;
  }
}
